document.addEventListener('DOMContentLoaded', function() {

  let newsVideoBtns = document.querySelectorAll('.news-video-btn');
  newsVideoBtns && newsVideoBtns.forEach(function(el) {
     el.addEventListener('click', function() {
         let video = this.dataset.video;
         if (!this.querySelector('iframe') && video) {
             this.insertAdjacentHTML('afterbegin',video);
             let iframe = $(this).find('iframe');
             this.classList.add('is-hidden');
             iframe[0].onload = function(){
                 $(iframe)[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
             };
             // var iframeDoc = $(iframe)[0].contentDocument || $(iframe)[0].contentWindow.document;
         }
     });
  });

  let newsSslider = document.querySelectorAll('.news-single-slider-wrp');
  if (newsSslider.length) {
      newsSslider.forEach((el)=>{
        console.log("el", el);
        let slNav = el.querySelector('.sl-nav');
        if(!slNav){
          return false
        }
        let slPag = el.querySelector('.swiper-pagination');
        let slider = new Swiper(el.querySelector(".swiper-container"), {
            slidesPerView: 'auto',
            spaceBetween: 8,
            navigation: {
                prevEl: slNav.querySelector('.sl-nav__btn--prev'),
                nextEl: slNav.querySelector('.sl-nav__btn--next'),
            },
            pagination: {
              el: slPag,
              clickable: true,
          },
        });
      })

  }


});